import nonEmptyString from './nonEmptyStringValidator.js'

// Note that this file mirrors a validation rule in the backend

/**
 *
 * @param {string} input - the complete email address
 * @returns
 */
export default function (input) {
    return !!(nonEmptyString(input) && input.match(/^\S+@\S+\.[a-zA-Z]+$/g))
}
